// Pagination.js — 페이지 번호 10개 단위 묶음 + 이전/다음 묶음 (음식검색·내 음식·음식풀 공용)
import React from 'react';
import './ui.css';

export default function Pagination({ page, total, pageSize = 10, onChange }) {
  const last = Math.max(1, Math.ceil(total / pageSize));
  if (last <= 1) return null;

  const groupStart = Math.floor((page - 1) / 10) * 10 + 1;
  const groupEnd = Math.min(groupStart + 9, last);
  const pages = [];
  for (let p = groupStart; p <= groupEnd; p += 1) pages.push(p);

  const go = (p) => { if (p >= 1 && p <= last && p !== page) onChange(p); };

  return (
    <nav className="pagination" aria-label="페이지">
      <button type="button" onClick={() => go(groupStart - 1)} disabled={groupStart === 1} aria-label="이전 10페이지">‹</button>
      {pages.map((p) => (
        <button
          key={p}
          type="button"
          className={p === page ? 'current' : ''}
          aria-current={p === page ? 'page' : undefined}
          onClick={() => go(p)}
        >
          {p}
        </button>
      ))}
      <button type="button" onClick={() => go(groupEnd + 1)} disabled={groupEnd === last} aria-label="다음 10페이지">›</button>
    </nav>
  );
}
